"use strict";
/**
 *  timeCueModule Module
 *
    Description 策划中心 指挥监测中心 自定义热点内容管理
 *  Author: fanglijuan 2017-7-17
 */
angular.module('planCommandMonitorCustomHotspotContentMgrModule', [])
    .controller('planCommandMonitorCustomHotspotContentMgrController', ["$scope", "$filter", "trsHttpService", 'planCommandMonitorService', 'initComDataService', '$q', 'resourceCenterService',
        function ($scope, $filter, trsHttpService, planCommandMonitorService, initComDataService, $q, resourceCenterService) {
            initStatus();
            initData();
            /**
             * [initStatus description：初始化状态]
             * @return {[type]} [description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    copyCurrPage: '',
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20
                };
                $scope.cusinfos = {
                    hours: {}, //用于接收承载24小时的数据以及选中值
                    //用于接收早中晚会按钮数据的对象
                    meetings: {
                        values: {}
                    },
                };
                addCusinfos(); //循环遍历出hours中的数据
                var defaultDate = new Date(); //获取当前时间
                defaultDate = Date.parse(defaultDate);
                defaultDate = timeStamp(defaultDate);
                $scope.cheDate = defaultDate; //当前时间的标准格式
                $scope.isOnThatDay = true; //用于判断是否是当天的额条件
                $scope.nowHour = $filter("date")(Date.parse(new Date()), "HH");
                $scope.cusinfos.hours.curValue.value = $filter("date")(Date.parse(new Date()), "HH");
                $scope.cusinfos.hours.curValue.name = $filter("date")(Date.parse(new Date()), "HH");
                judgeDate();
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                $scope.params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'customHotPointMgr',
                    "method": 'getHotPointList',
                    "page_size": $scope.page.PAGESIZE,
                    "page_no": $scope.page.CURRPAGE - 1,
                    "hot_type": '0',
                    "search_hour": $scope.ischecked
                };
                $scope.copyParams = angular.copy($scope.params); //copy初始的的参数数据用于小时时间按钮的回调中用到
            }
            /**
             * [addCusinfos description：用于循环遍历出hour中的24小时的数据]
             */
            function addCusinfos() {
                $scope.cusinfos.hours.values = [];
                $scope.cusinfos.hours.curValue = { value: '', name: '' };
                for (var i = 1; i < 25; i++) {
                    var strV = '',
                        strS = '';
                    if (i < 10) {
                        strV += "0" + i;
                        strS += "0" + i; //用于确保数据的HH格式
                    } else if (i === 24) {
                        strV += "00";
                        strS += i; //24时的value值为00
                    } else {
                        strV += i;
                        strS += i; //其余值则宝石时间与值以及变现形式一致
                    }
                    $scope.cusinfos.hours.values[i - 1] = { value: '', show: '' };
                    $scope.cusinfos.hours.values[i - 1].value = strV;
                    $scope.cusinfos.hours.values[i - 1].show = strS;
                }
                $scope.cusinfos.hours.curValue.value = '';
                $scope.cusinfos.hours.curValue.name = '';
            }
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                initDropDown();
                requestMeetData().then(function () {
                    requestData();
                    judgeMeet();
                    fieldMor("1");
                    fieldMor("2");
                    fieldMor("3");
                });
            }
            /** [fieldMor description：拼接三会信息字符串] */
            function fieldMor(type) {
                $scope['meetMorTxt' + type] = '';
                var fieldMor1 = $scope.meetInfo['pointdayFr' + type] == 1 ? "当日" : "昨日";
                var fieldMor2 = $scope.meetInfo['pointdayTo' + type] == 1 ? "当日" : "昨日";
                $scope['meetMorTxt' + type] += "*" + fieldMor1 + $scope.meetInfo['pointFr' + type] + '-' + fieldMor2 + $scope.meetInfo['pointTo' + type];
            }
            /**
             * [judgeDate description:判断可以是否需要禁用]
             */
            function judgeDate() {
                // var cusList2 = [];
                // cusList2.push($scope.cusinfos.years.curValue.value);
                // cusList2.push($scope.cusinfos.months.curValue.value);
                // cusList2.push($scope.cusinfos.days.curValue.value);
                // var judgeInfo = cusList2.join("/");
                // console.log(judgeInfo);
                var judgeInfo = $scope.cheDate;
                judgeInfo = Date.parse(judgeInfo);
                // console.log(judgeInfo);
                var judgeInfo1 = judgeInfo + 86400000;
                var nowTime = new Date();
                nowTime = Date.parse(nowTime);
                // console.log(nowTime);
                $scope.timeJudge = nowTime < judgeInfo;
                $scope.timeJudge1 = nowTime < judgeInfo1;
            }
            /**
             * [judgeMeet description：判断是否禁用三会按钮]
             */
            function judgeMeet() {
                var judgeCondi = (!($scope.timeJudge)) && ($scope.timeJudge1);
                if (judgeCondi) {
                    mPointJudge('1');
                    mPointJudge('2');
                    mPointJudge('3');
                } else {
                    $scope.meetPointJudge1 = false;
                    $scope.meetPointJudge2 = false;
                    $scope.meetPointJudge3 = false;
                }
            }
            /** [mPointJudge description:封装用于判断三会按钮是否禁用] */
            function mPointJudge(type) {
                var mpj = $scope['meetPointJudge' + type] = '';
                if ($scope.meetInfo['pointdayFr' + type] == "2") {
                    $scope.meetPointJudge = false;
                } else {
                    var meetCondition = $scope.meetInfo['pointFr' + type];
                    var strA = meetCondition.slice(0, 2);
                    var strB = meetCondition.slice(3, 5);
                    var nowMeetHour = new Date().getHours();
                    var nowMeetMin = new Date().getMinutes();
                    $scope['meetPointJudge' + type] = !((nowMeetHour > strA) || ((nowMeetHour == strA) && (nowMeetMin > strB)));
                }
            }
            /**
             * [description:当日期选择监听它的变化]
             */
            $scope.$watch('cheDate', function () {
                judgeDate();
                if ($scope.meetInfo != undefined) {
                    judgeMeet();
                }
                var nowTime2 = new Date();
                nowTime2 = Date.parse(nowTime2);
                nowTime2 = timeStamp(nowTime2);
                var compareTime = Date.parse($scope.cheDate);
                compareTime = timeStamp(compareTime);
                $scope.isOnThatDay = (nowTime2 === compareTime);
                if (!$scope.isOnThatDay) {
                    $scope.cusinfos.hours.curValue.value = '24';
                    $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                } else {
                    $scope.cusinfos.hours.curValue.value = new Date().getHours();
                    $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                }
            });
            /**
             * [timeStamp:将日期字符串转化为标准格式]
             */
            function timeStamp(group) {
                return $filter("date")(group, "yyyy-MM-dd").toString();
            }
            /**
             * [judgeCity description：为了获取标题的地域信息]
             * @return {[type]} [description]
             */
            function judgeArea() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'searchAreaHot',
                    "sceneid": 10
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var areaTimeT = "";
                    if (data.town === null) {
                        $scope.areaName = data.city;
                    } else {
                        $scope.areaName = data.city + data.town;
                    }
                    if ($scope.cusinfos.hours.curValue.value >= 0 && $scope.cusinfos.hours.curValue.value <= 23) {
                        areaTimeT = $scope.cusinfos.hours.curValue.value + "时";
                    }
                    var date = $scope.cheDate;
                    date = Date.parse(date);
                    date = timeStamp(date);
                    var dateArr = date.split("-");
                    $scope.dateShow = dateArr[0] + "年" + dateArr[1] + "月" + dateArr[2] + "日" + areaTimeT + '新疆' + $scope.areaName +
                        "热点热度表";
                });
            }
            /**
             * [requestData description] 请求数据
             */
            function requestData() {
                // var cusList = [];
                // cusList.push($scope.cusinfos.years.curValue.value);
                // cusList.push($scope.cusinfos.months.curValue.value);
                // cusList.push($scope.cusinfos.days.curValue.value);
                // var dateInfo = cusList.join("-");
                var deffer = $q.defer();
                judgeArea();
                var date = $scope.cheDate;
                date = Date.parse(date);
                date = timeStamp(date);
                $scope.params.area_id = $scope.meetInfo.finalArea;
                $scope.params.search_date = date;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "post").then(function (data) {
                    $scope.cusinfos.infos = data.mapResult.content.record;
                    $scope.page.ITEMCOUNT = data.mapResult.content.record_count;
                    $scope.page.PAGECOUNT = data.mapResult.content.pagecount;
                    $scope.transmitSearch = $scope.params.search_hour;
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [requestMeetData description:获取的3会的页面实现内容]
             */
            function requestMeetData() {
                var deffer = $q.defer();
                var meetParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'customHotPointMgr',
                    "method": 'getCustomHotPoint',
                    "page_size": 10,
                    "page_no": 0
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), meetParams, 'get').then(function (data) {
                    $scope.cusinfos.meetings.values = data.mapResult.content[0];
                    $scope.meetInfo = $scope.cusinfos.meetings.values;
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [switchBtn description:显示按钮的触发处理函数]
             */
            $scope.switchBtn = function (group) {
                if (group.displayFlag === 1) {
                    group.displayFlag = 0;
                } else {
                    group.displayFlag = 1
                }
                updateDisplay(group);
            };
            /**
             * [initDropDown description] 初始化下拉框
             */
            function initDropDown() {
                $scope.status.timeArray = initComDataService.logMgrTime();
                $scope.status.timeSelected = $scope.status.timeArray[1];
            }
            /**
             * [selectPageNum description] 选择每页显示的数据数量
             */
            $scope.selectPageNum = function () {
                $scope.status.CurrPageCopy = 1;
                $scope.params.page_no = $scope.page.CURRPAGE - 1;
                $scope.params.page_size = $scope.page.PAGESIZE;
                requestData();
            };
            /**
             * [pageChanged description]分页
             */
            $scope.pageChanged = function () {
                // console.log($scope.page.CURRPAGE);
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                $scope.params.page_no = $scope.page.CURRPAGE - 1;
                requestData();
            };
            /*跳转指定页面*/
            $scope.jumpToPage = function () {
                if (!$scope.status.copyCurrPage) return;
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                $scope.params.page_no = $scope.status.copyCurrPage - 1;
                requestData();
            };
            /**
             * [changeFlagId description：更改标志ID]
             */
            $scope.changeFlagId = function (info) {
                planCommandMonitorService.editSignedArticle('', '', '', '', info.signGuid,
                    function (guidValue) {
                        var flagParams = {
                            "serviceid": 'mlf_bigdatascreen',
                            "methodname": 'queryDataFromBigScreen',
                            "modalname": 'areaHotPointFunCommon',
                            "method": 'updateSignGuid',
                            "guid_updt": guidValue,
                            "areahot_id": info.areahot_id,
                            "search_hour": $scope.cusinfos.hours.curValue.value,
                            "guid_old": info.signGuid,
                            "hot_type": '0',
                            "display_flag": info.displayFlag
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), flagParams, 'post').then(function () {
                            requestData();
                        });
                    },
                    function () {
                        console.log("触发了这里的");
                    });
            };
            /**
             * [exportExcel description: 导出excel]
             */
            $scope.exportExcel = function (group) {
                var title = group.sighTitle.replace(/%/g, "%25");
                var url = "/wcm/bigdata.do?areahot_id=" + group.areahot_id + "&filename=" + title + "&method=hotpointExport&search_hour=" + $scope.cusinfos.hours.curValue.value + "&modalname=&hot_type='0'";
                window.open(url);
            };
            //127.0.0.1:8080/wcm/bigdata.do?areahot_id=eb5eb5c3-7ea4-4bff-9a25-313bf1d64087&cluster_guids=907410937580507136;&filename=杭绍台铁路下月开工 杭州到台州今后只需一小时&method=hopointExport&search_hour=22&modalname=
            /**
             * [searchHot description：通过查询查询热点并再次请求该条件的数据]
             * @return {[type]} [description]
             */
            $scope.searchHot = function () {
                var hotJudge = (!$scope.timeJudge) && (($scope.cusinfos.hours.curValue.value <= $scope.nowHour) || (!$scope.timeJudge1) || ($scope.cusinfos.hours.curValue.value >= 97));
                if (hotJudge) {
                    requestData();
                } else {
                    planCommandMonitorService.singleCallbackConfirm('提示信息', '请调整查询时间!', function () { });
                }
            };
            /**
             * [getHours description:获取到需要查询的时间段]
             * @return {[type]} [description]
             */
            $scope.getHours = function (group) {
                $scope.params = $scope.copyParams;
                $scope.cusinfos.hours.curValue.value = group.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                judgeDate();
            };
            /**
             * [dayHotSearch description：当日热点的选中小骨]
             * @return {[type]} [description]
             */
            $scope.dayHotSearch = function () {
                $scope.cusinfos.hours.curValue.value = '24';
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
            };
            /**
             * [getMeeting description:获取会议的选择要求]
             * @return {[type]} [description]
             */
            $scope.getMeeting = function (type) {
                $scope.cusinfos.hours.curValue.value = type == '1' && '97' || type == '2' && '98' || type == '3' && '99';
                $scope.params.day_flag_from = $scope.meetInfo['pointdayFr' + type];
                $scope.params.day_flag_to = $scope.meetInfo['pointdayTo' + type];
                $scope.params.day_time_from = $scope.meetInfo['pointFr' + type];
                $scope.params.day_time_to = $scope.meetInfo['pointTo' + type];
                $scope.params.search_hour = $scope.cusinfos.hours.curValue.value;
                $scope.ischecked = $scope.cusinfos.hours.curValue.value;
            };
            /**
             * [updateDisplay description:更新显示按钮的状态]
             */
            function updateDisplay(group) {
                if (group.displayFlag === 1) {
                    var judge = true;
                } else {
                    var judge = false;
                }
                $scope.disParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'areaHotPointFunCommon',
                    "method": 'updateDisplayFlag',
                    "search_hour": $scope.cusinfos.hours.curValue.value,
                    "display_flag": judge,
                    "areahot_id": group.areahot_id
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.disParams, 'post');
            }
        }
    ]);